import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import PatientList from '@/components/Patient/PatientList'
import PatientEdit from '@/components/Patient/PatientEdit'
import UserList from '@/components/User/UserList'
import UserEdit from '@/components/User/UserEdit'
import TagList from '@/components/Tag/TagList'
import TagEdit from '@/components/Tag/TagEdit'
import RecordList from '@/components/Record/RecordList'
import RecordEdit from '@/components/Record/RecordEdit'
import RoleList from '@/components/Role/RoleList'
import RoleEdit from '@/components/Role/RoleEdit'
import ItemList from '@/components/Item/ItemList'
import ItemEdit from '@/components/Item/ItemEdit'
import LocationList from '@/components/Location/LocationList'
import LocationEdit from '@/components/Location/LocationEdit'
import TagGroupList from '@/components/TagGroup/TagGroupList'
import TagGroupEdit from '@/components/TagGroup/TagGroupEdit'
import OrsTestPatient from '@/components/Patient/OrsTestPatient'
import auth from '@/store/modules/auth'
import RecordTemplateList from '@/components/RecordTemplate/RecordTemplateList'
import RecordTemplateEdit from '@/components/RecordTemplate/RecordTemplateEdit'
import RecordTemplateGroupList from '@/components/RecordTemplateGroup/RecordTemplateGroupList'
import RecordTemplateGroupEdit from '@/components/RecordTemplateGroup/RecordTemplateGroupEdit'
import ClinicList from '@/components/Clinic/ClinicList'
import ClinicEdit from '@/components/Clinic/ClinicEdit'
import RecordOverview from '@/components/RecordOverview/RecordOverview'
import Backup from '@/components/Backup/Backup'

Vue.use(Router)

export default new Router({
  beforeEach: function (transition) {
    if (!transition.to.noAuth && !auth.state.user) {
      transition.redirect('/login')
      return
    }
    transition.next()
  },
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      noAuth: true
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      noAuth: true
    },
    {
      path: '/patient',
      name: 'PatientList',
      component: PatientList
    },
    {
      path: '/patient/add',
      name: 'PatientEdit',
      component: PatientEdit
    },
    {
      path: '/patient/:id',
      name: 'PatientEdit',
      component: PatientEdit
    },
    {
      path: '/user',
      name: 'UserList',
      component: UserList
    },
    {
      path: '/user/:id',
      name: 'UserEdit',
      component: UserEdit
    },
    {
      path: '/record',
      name: 'RecordList',
      component: RecordList
    },
    {
      path: '/record/:id',
      name: 'RecordEdit',
      component: RecordEdit
    },
    {
      path: '/role',
      name: 'RoleList',
      component: RoleList
    },
    {
      path: '/role/:id',
      name: 'RoleEdit',
      component: RoleEdit
    },
    {
      path: '/item',
      name: 'ItemList',
      component: ItemList
    },
    {
      path: '/item/:id',
      name: 'ItemEdit',
      component: ItemEdit
    },
    {
      path: '/location',
      name: 'LocationList',
      component: LocationList
    },
    {
      path: '/location/:id',
      name: 'LocationEdit',
      component: LocationEdit
    },
    {
      path: '/tag-group',
      name: 'TagGroupList',
      component: TagGroupList
    },
    {
      path: '/tag-group/:groupID/list',
      name: 'TagList',
      component: TagList
    },
    {
      path: '/tag-group/:groupID/tag/:id',
      name: 'TagEdit',
      component: TagEdit
    },
    {
      path: '/tag-group/:id',
      name: 'TagGroupEdit',
      component: TagGroupEdit
    },
    {
      path: '/record-template-group',
      name: 'RecordTemplateGroupList',
      component: RecordTemplateGroupList
    },
    {
      path: '/record-template-group/:groupID/list',
      name: 'RecordTemplateList',
      component: RecordTemplateList
    },
    {
      path: '/record-template-group/:groupID/record-template/:id',
      name: 'RecordTemplateEdit',
      component: RecordTemplateEdit
    },
    {
      path: '/record-template-group/:id',
      name: 'RecordTemplateGroupEdit',
      component: RecordTemplateGroupEdit
    },
    {
      path: '/ors-test-patient/:patientID/:recordID',
      name: 'OrsTestPatient',
      component: OrsTestPatient,
      noAuth: true
    },
    {
      path: '/clinic/:id',
      name: 'ClinicEdit',
      component: ClinicEdit
    },
    {
      path: '/clinic',
      name: 'ClinicList',
      component: ClinicList
    },
    {
      path: '/record-overview',
      name: 'RecordOverview',
      component: RecordOverview
    },
    {
      path: '/backup',
      name: 'Backup',
      component: Backup
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js